/**
 * Created by Alex Aguilar on 5/10/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('itineraryFlightsCtrl', itineraryFlightsCtrl)
        .controller('newItineraryFlightCtrl', newItineraryFlightCtrl)
        .controller('editItineraryFlightCtrl', editItineraryFlightCtrl)
        .controller('deleteItineraryFlightCtrl', deleteItineraryFlightCtrl);

    itineraryFlightsCtrl.$inject = ['$stateParams', 'linkService','itineraryFlights'];
    newItineraryFlightCtrl.$inject = ['$stateParams', 'linkService', 'itineraryFlightService', 'routeService','dialogService',
        'modelAircraftService', '$timeout'];
    editItineraryFlightCtrl.$inject = ['$stateParams', 'linkService', 'itineraryFlightService', 'routeService', 'dialogService',
        'modelAircraftService','routeItinerary','$timeout'];
    deleteItineraryFlightCtrl.$inject = ['itineraryFlightService', '$uibModalInstance', '$stateParams'];

    function itineraryFlightsCtrl($stateParams, linkService,itineraryFlights){
        var vm = this;
        vm.linkService = linkService;
        vm.itineraries = [];
        vm.itineraryDisabled = [];
        vm.contItineraryDisable = 0;
        vm.itineraryId = $stateParams.id;
        vm.itineraryName = $stateParams.name;
        vm.routeItineraries = (itineraryFlights.data._embedded)?itineraryFlights.data._embedded.routeItineraries:[];
        vm.pages = itineraryFlights.data.page;
    }
    function newItineraryFlightCtrl($stateParams, linkService, itineraryFlightService, routeService, dialogService,
                                    modelAircraftService, $timeout){
        var vm = this;
        vm.itineraryId = $stateParams.id;
        vm.itineraryName = $stateParams.name;
        vm.showRequired = true;
        vm.modelAircrafts = [];
        vm.routes = [];
        vm.structures = [];
        vm.weekDays = [];
        vm.routeItinerary = {
            'departures': [],
            'flightNumber': "",
            'itineraryId': 0,
            'routeId': 0
        };
        vm.stretchRoutes = [];
        vm.departures = [];
        vm.postDays = [];
        vm.dayCheck = {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false};
        vm.isDisabledDay = true;
        vm.isDisabledRoute = true;
        vm.isDisabledModelAircraft = true;
        vm.flightTimes = {};
        vm.requiredCheck = true;
        vm.cont = 0;

        vm.itineraryFlight = {
            'day': [],
            'weekDays': [],
            'days': [],
            'departures': [],
            'route': {},
            'flightNumber': ''
        };

        getLoadFormRouteItinerary(itineraryFlightService, vm);

        vm.resetRouteSegments = function (isDisabledRoute, isDisabledModelAircraft) {
            vm.isDisabledRoute = isDisabledRoute;
            vm.isDisabledModelAircraft = isDisabledModelAircraft;
            vm.dayCheck = {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false};
            vm.itineraryFlight.departures = [];
            vm.isDisabledDay = vm.isDisabledRouteModelAircraft(vm.isDisabledRoute, vm.isDisabledModelAircraft);
        }

        vm.isDisabledRouteModelAircraft = function (isDisabledRoute, isDisabledModelAircraft) {
            var res = false;

            if(!isDisabledRoute && isDisabledModelAircraft) {
                res = true;
            }

            if(!isDisabledRoute && !isDisabledModelAircraft) {
                res = false;
            }

            if(isDisabledRoute && !isDisabledModelAircraft) {
                res = true;
            }

            if(!isDisabledRoute && !isDisabledModelAircraft) {
                res = false;
            }
            return res;
        }

        vm.getRouteSegments = function(routeId, itineraryFlightDay){
            if(vm.itineraryFlight.route.routeId !== undefined){
                vm.resetRouteSegments(false, vm.isDisabledModelAircraft);
                removeAllCheckDay(itineraryFlightDay);
                routeService.getRouteDetail(vm.itineraryFlight.route.routeId)
                    .then(function(res){
                        vm.stretchRoutes = res.data._embedded.stretchRoutes;
                        vm.routeId = res.data.routeId;
                        vm.isDisabledRoute = false;
                        vm.isDisabledDay = vm.isDisabledRouteModelAircraft(vm.isDisabledRoute, vm.isDisabledModelAircraft);
                    });
            }else {
                vm.resetRouteSegments(true, vm.isDisabledModelAircraft);
            }
        }

        vm.someSelected = function (object) {
            return Object.keys(object).some(function (key) {
                return object[key];
            });
        };

        vm.getModelAircraftStructures = function(modelAircraft){
            if(vm.itineraryFlight.modelAircraft !== undefined){
                vm.resetRouteSegments(vm.isDisabledRoute, false);
                getModelAircraftStructures(modelAircraftService, vm, vm.itineraryFlight.modelAircraft);
                getModelAircraftFlightTimes(modelAircraftService, vm.itineraryFlight.modelAircraft,vm);
                vm.isDisabledModelAircraft = false;
                vm.isDisabledDay = vm.isDisabledRouteModelAircraft(vm.isDisabledRoute, vm.isDisabledModelAircraft);
            }else{
                vm.resetRouteSegments(vm.isDisabledRoute, true);
                vm.structures = [];
                vm.flightTimes = {};
            }
        }

        vm.addRemoveSegmentRouteDay = function(day, dayCode) {
            if (vm.dayCheck[dayCode] === true) {
                if(vm.stretchRoutes.length > 0){
                    vm.itineraryFlight.departures.push({'day': day, 'stretchRoutes': []});
                    var departuresLength = vm.itineraryFlight.departures.length;
                    angular.forEach(vm.stretchRoutes, function(stretchRoute){
                        vm.itineraryFlight.departures[departuresLength-1].stretchRoutes.push({
                            'arrivalDay': day,
                            'arrivalTime': '',
                            'departureTime': '',
                            'order': stretchRoute.orden,
                            'originId': stretchRoute.originId,
                            'destinyId': stretchRoute.destinyId,
                            'segment': stretchRoute._embedded.segment
                        });
                    });
                }else{
                    dialogService.dialogRequiredError('ITINERARY_FLIGHT.TABLE.ROUTE');
                }
            } else if (vm.dayCheck[dayCode] === false) {
                var pos = itineraryFlightService.getPositionItineraryFlightDepartures(vm.itineraryFlight.departures, dayCode);
                if(pos !== -1) {
                    vm.itineraryFlight.departures.splice(pos, 1);
                }
            } else if(vm.dayCheck[dayCode] === undefined) {
                vm.itineraryFlight.departures = [];
            }
        }

        vm.onChangeDepartureArrivalTime = function (indexX, indexY, form) {
            validateDepartureArrivalTime(vm, indexX, indexY, form, $timeout);
        }

        vm.saveRouteItinerary = function(isValid, itineraryFlight){
            if(isValid){
                angular.forEach(itineraryFlight.departures, function(departure){
                    var dayOfWeekId = departure.day.code;
                    angular.forEach(departure.stretchRoutes, function(stretchRoute){
                        var departureTime = formatTime(stretchRoute.departureTime, 2),
                            arrivalTime = formatTime(stretchRoute.arrivalTime, 2);
                        vm.departures.push({
                            'arrivalDay': stretchRoute.arrivalDay.code,
                            'arrivalTime': arrivalTime,
                            'dayOfWeekId': dayOfWeekId,
                            'departureTime': departureTime,
                            'destinyAirportId': stretchRoute.destinyId,
                            'orderDeparture': stretchRoute.order,
                            'originAirportId': stretchRoute.originId
                        })
                    });
                });

                vm.routeItinerary = {
                    'departures': vm.departures,
                    'flightNumber': itineraryFlight.flightNumber,
                    'itineraryId': parseInt(vm.itineraryId),
                    'routeId': itineraryFlight.route.routeId,
                    'structureId': itineraryFlight.structure.structureId
                };

                itineraryFlightService.saveItineraryFlight(vm.routeItinerary)
                    .then(function(){
                        linkService.reloadRoute('itineraryFlight', {id : vm.itineraryId});
                    })
            }
        }
        vm.change =  function(){
            vm.requiredCheck = (isRequiredCheck(vm))?true:false;
            vm.cont++;
        }

        vm.copyInformation = function(){
            for(var i=0; i < vm.itineraryFlight.departures[0].stretchRoutes.length; i++){
                for(var j=1; j < vm.itineraryFlight.departures.length; j++){
                    vm.itineraryFlight.departures[j].stretchRoutes[i].arrivalTime = vm.itineraryFlight.departures[0].stretchRoutes[i].arrivalTime;
                    vm.itineraryFlight.departures[j].stretchRoutes[i].departureTime = vm.itineraryFlight.departures[0].stretchRoutes[i].departureTime;
                }
            }

        }
    }
    function editItineraryFlightCtrl( $stateParams, linkService,itineraryFlightService, routeService, dialogService,
                                      modelAircraftService,routeItinerary, $timeout){
        var vm = this;
        vm.itineraryFlightId = $stateParams.itineraryFlightId;
        vm.itineraryId = $stateParams.itineraryId;
        vm.itineraryName = $stateParams.name;
        vm.weekDays = [];
        vm.dayStretchRoutes = [];
        vm.postDays = [];
        vm.departures = [];
        vm.stretchRoutes = [];
        vm.itineraryFlight = {
            'day': [],
            'weekDays': [],
            'days': [],
            'departures': [],
            'route': routeItinerary.data._embedded.route,
            'flightNumber': routeItinerary.data.flightNumber,
            'modelAircraft': (routeItinerary.data._embedded.structure._embedded) ?
                routeItinerary.data._embedded.structure._embedded.modelAircraft : {},
            'structure': routeItinerary.data._embedded.structure
        };

        vm.flightTimes = {};
        vm.dayCheckSelect = false;
        vm.dayCheck = {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false};
        vm.isDisabledDay = false;
        vm.requiredCheck = false;
        vm.values = [];

        vm.resetRouteSegments = function () {
            vm.isDisabledDay = true;
            vm.dayCheck = {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false};
            vm.itineraryFlight.departures = [];
        }

        vm.getRouteSegments = function(routeId, itineraryFlightDay){
            if(vm.itineraryFlight.route.routeId !== undefined){
                vm.resetRouteSegments();
                removeAllCheckDay(vm.itineraryFlight.day);
                routeService.getRouteDetail(vm.itineraryFlight.route.routeId)
                    .then(function(res){
                        vm.stretchRoutes = res.data._embedded.stretchRoutes;
                        vm.routeId = res.data.routeId;
                        vm.isDisabledDay = false;
                    });
            }else {
                vm.resetRouteSegments();
            }
        }

        vm.getModelAircraftStructures = function(modelAircraft){
            if(modelAircraft !== undefined){
                getModelAircraftStructures(modelAircraftService, vm, modelAircraft);
                getModelAircraftFlightTimes(modelAircraftService, modelAircraft,vm);
            }else{
                vm.structures = [];
                vm.flightTimes = {};
            }
        }

        getRoutes(vm.itineraryFlight.route.routeId);
        getSegmentRouteDays(routeItinerary.data._embedded.weekDays);
        //getModelAircraftStructures(modelAircraftService, vm,vm.itineraryFlight.modelAircraft);
        getLoadFormRouteItinerary(itineraryFlightService, vm);
        vm.getModelAircraftStructures(vm.itineraryFlight.modelAircraft);

        vm.buttonSave = true;
        vm.old = angular.copy(vm.itineraryFlight);
        vm.oldCheck =  angular.copy(vm.dayCheck);

        function getRoutes(routeId){
            routeService.getRouteDetail(routeId)
                .then(function(res){
                    vm.stretchRoutes = res.data._embedded.stretchRoutes;
                });
        }

        function getSegmentRouteDays(weekDays){
            var dayArray = days();
            vm.isDisabledDay = false;
            angular.forEach(weekDays, function(weekDay, key){
                var weekDayJson = {'code': weekDay.code, 'name': weekDay.name, 'initials': weekDay.initials};
                vm.dayCheck[weekDay.code] = true;
                vm.itineraryFlight.days.push(weekDayJson);
                vm.itineraryFlight.departures.push({'day': weekDayJson, 'stretchRoutes': []});

                angular.forEach(weekDay._embedded.departuresItinerary, function(departureItinerary){
                    var originDestinyIds = linkService.getLinkIds(departureItinerary._embedded.segment._links.self.href),
                        departureTime = formatTime(departureItinerary.departureTime, 1),
                        arrivalTime = formatTime(departureItinerary.arrivalTime, 1);

                    vm.itineraryFlight.departures[key].stretchRoutes.push({
                        'arrivalDay': dayArray[departureItinerary.arrivalDay - 1],
                        'arrivalTime': arrivalTime ,
                        'departureTime': departureTime ,
                        'order': departureItinerary.order,
                        'originId': originDestinyIds[0],
                        'destinyId': originDestinyIds[1],
                        'segment': departureItinerary._embedded.segment,
                        '_embedded': departureItinerary._embedded.weekDay
                    });
                });
            });

            vm.onChangeDepartureArrivalTime = function (indexX, indexY, form) {
                validateDepartureArrivalTime(vm, indexX, indexY, form, $timeout);
            }

            angular.forEach(dayArray, function(dayObject){
                var value = false;
                angular.forEach(weekDays, function(weekDay){
                    if(dayObject.code == weekDay.code){
                        value = true;
                        vm.values.push(weekDay.code);
                        vm.postDays.push(weekDay.code);
                    }
                });
                vm.itineraryFlight.weekDays.push({
                    'code': dayObject.code,
                    'name': dayObject.name,
                    'initials': dayObject.initials,
                    'value': value
                });

                vm.itineraryFlight.day.push(value);

            });
        }

        vm.someSelected = function (object) {
            return Object.keys(object).some(function (key) {
                return object[key];
            });
        };

        vm.getModelAircraftStructures = function(modelAircraft){
            if(modelAircraft != undefined){
                getModelAircraftStructures(modelAircraftService, vm, modelAircraft);
                getModelAircraftFlightTimes(modelAircraftService, modelAircraft,vm);
            }else{
                vm.structures = [];
                vm.flightTimes = {};
            }
        }

        vm.isOneDaySelect = function (days) {
            var cont = 0;
            for (var key in days) {
                if(days[key] === true) {
                    cont++
                }
            }
            return cont;
        }

        vm.addAndRemoveSegmentRouteDay = function (day, dayCode) {
            if (vm.dayCheck[dayCode] === true) {
                if(vm.stretchRoutes.length > 0){
                    vm.itineraryFlight.departures.push({'day': day, 'stretchRoutes': []});
                    var departuresLength = vm.itineraryFlight.departures.length;
                    angular.forEach(vm.stretchRoutes, function(stretchRoute){
                        vm.itineraryFlight.departures[departuresLength-1].stretchRoutes.push({
                            'arrivalDay': day,
                            'arrivalTime': '',
                            'departureTime': '',
                            'order': stretchRoute.orden,
                            'originId': stretchRoute.originId,
                            'destinyId': stretchRoute.destinyId,
                            'segment': stretchRoute._embedded.segment
                        });
                    });
                }else{
                    dialogService.dialogRequiredError('ITINERARY_FLIGHT.TABLE.ROUTE');
                }
            } else if (vm.dayCheck[dayCode] === false) {
                var pos = itineraryFlightService.getPositionItineraryFlightDepartures(vm.itineraryFlight.departures, dayCode);
                if(pos !== -1) {
                    vm.itineraryFlight.departures.splice(pos, 1);
                }
            } else if(vm.dayCheck[dayCode] === undefined) {
                vm.itineraryFlight.departures = [];
            }
        }

        vm.saveRouteItinerary = function(isValid, itineraryFlight){
            if(isValid){
                angular.forEach(itineraryFlight.departures, function(departure){
                    var dayOfWeekId = departure.day.code;
                    angular.forEach(departure.stretchRoutes, function(stretchRoute){
                        var departureTime = formatTime(stretchRoute.departureTime, 2),
                            arrivalTime = formatTime(stretchRoute.arrivalTime, 2);
                        vm.departures.push({
                            'arrivalDay': stretchRoute.arrivalDay.code,
                            'arrivalTime': arrivalTime,
                            'dayOfWeekId': dayOfWeekId,
                            'departureTime': departureTime,
                            'destinyAirportId': stretchRoute.destinyId,
                            'orderDeparture': stretchRoute.order,
                            'originAirportId': stretchRoute.originId
                        })
                    });
                });

                vm.routeItinerary = {
                    'departures': vm.departures,
                    'flightNumber': itineraryFlight.flightNumber,
                    'itineraryId': parseInt(vm.itineraryId),
                    'routeId': itineraryFlight.route.routeId,
                    'structureId': itineraryFlight.structure.structureId
                };

                itineraryFlightService.updateRouteItinerary(vm.routeItinerary, vm.itineraryFlightId)
                    .then(function(){
                        linkService.reloadRoute('itineraryFlight', {id : vm.itineraryId});
                    });
            }
        }

        vm.change = function(){
            if(vm.itineraryFlight.route!=undefined && vm.itineraryFlight.route.routeId==vm.old.route.routeId &&
                vm.itineraryFlight.flightNumber.toUpperCase()==vm.old.flightNumber.toUpperCase() &&
                vm.itineraryFlight.modelAircraft!=undefined && vm.itineraryFlight.modelAircraft.name==vm.old.modelAircraft.name &&
                vm.itineraryFlight.structure.structureId!=undefined && vm.itineraryFlight.structure.structureId==vm.old.structure.structureId &&
                compareDayCheck()){
                $timeout(function () {
                    for(var i=0; i<vm.itineraryFlight.departures.length; i++){
                        var flagStretch = true;
                        for(var j=0; j<vm.itineraryFlight.departures[i].stretchRoutes.length; j++){
                            var departureTime = vm.itineraryFlight.departures[i].stretchRoutes[j].departureTime;
                            var departureTimeOld = vm.old.departures[i].stretchRoutes[j].departureTime;
                            var posDT = departureTime.indexOf(":");
                            var posDTOld = departureTimeOld.indexOf(":");

                            var arrivalDay = vm.itineraryFlight.departures[i].stretchRoutes[j].arrivalDay;
                            var arrivalDayOld = vm.old.departures[i].stretchRoutes[j].arrivalDay;
                            var arrivalTime = vm.itineraryFlight.departures[i].stretchRoutes[j].arrivalTime;
                            var arrivalTimeOld = vm.old.departures[i].stretchRoutes[j].arrivalTime;
                            var posAT = arrivalTime.indexOf(":");
                            var posATOld = arrivalTimeOld.indexOf(":");

                            if(parseInt(departureTime.substring(0,posDT)) == parseInt(departureTimeOld.substring(0,posDTOld)) &&
                                parseInt(departureTime.substring(posDT+1)) == parseInt(departureTimeOld.substring(posDTOld+1)) &&
                                parseInt(arrivalTime.substring(0,posAT)) == parseInt(arrivalTimeOld.substring(0,posATOld)) &&
                                parseInt(arrivalTime.substring(posAT+1)) == parseInt(arrivalTimeOld.substring(posATOld+1)) &&
                                arrivalDay!=undefined && arrivalDay.code==arrivalDayOld.code){
                                vm.buttonSave = true;
                            }else{
                                vm.buttonSave = false;
                                flagStretch = false;
                                break;
                            }
                        }
                        if(!flagStretch){
                            break;
                        }
                    }
                },1);

            }else{
                vm.buttonSave = false;
            }

            vm.requiredCheck = (isRequiredCheck(vm))?true:false;
        }

        function compareDayCheck(){
            for(var i=1; i<=7; i++){
                if(vm.dayCheck[i]!=vm.oldCheck[i]){
                    return false;
                    break;
                }
            }
            return true;
        }

        vm.copyInformation = function(){
            for(var i=0; i < vm.itineraryFlight.departures[0].stretchRoutes.length; i++){
                for(var j=1; j < vm.itineraryFlight.departures.length; j++){
                    vm.itineraryFlight.departures[j].stretchRoutes[i].arrivalTime = vm.itineraryFlight.departures[0].stretchRoutes[i].arrivalTime;
                    vm.itineraryFlight.departures[j].stretchRoutes[i].departureTime = vm.itineraryFlight.departures[0].stretchRoutes[i].departureTime;
                }
            }

        }
    }

    function deleteItineraryFlightCtrl(itineraryFlightService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.routeItineraryId = $stateParams.routeItineraryId;
        vm.deleteItineraryFlight = function(){
            itineraryFlightService.deleteRouteItinerary(vm.routeItineraryId)
                .then(function(){
                    $uibModalInstance.close(true);
                });
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
    function getLoadFormRouteItinerary(itineraryFlightService, vm){
        itineraryFlightService.getLoadFormRouteItinerary()
            .then(function(res){
                vm.modelAircrafts = res.data.modelAircrafts._embedded.modelAircrafts;
                vm.routes = res.data.routes._embedded.routes;
                vm.weekDays = res.data.weekDays._embedded.weekDays;
            })
    }

    function getModelAircraftStructures(modelAircraftService, vm, modelAircraft){
        modelAircraftService.getModelAircraftStructures(modelAircraft.makerId, modelAircraft.modelAircraftId)
            .then(function(res){
                if(res.data._embedded){
                    vm.structures = res.data._embedded.structures;
                }else{
                    vm.structures = [];
                }
            });
    }

    function getModelAircraftFlightTimes(modelAircraftService, modelAircraft,vm){
        modelAircraftService.getFlightTimes(modelAircraft.makerId, modelAircraft.modelAircraftId)
            .then(function(res){
                if(res.data._embedded){
                    angular.forEach(res.data._embedded.flightTimes, function(flightTime){
                        var nameKey = flightTime._embedded.segment.name;
                        nameKey = nameKey.replace(/[-() ]/g, "_");
                        vm.flightTimes[nameKey] = {'time': flightTime.time}
                    });
                }else{
                    vm.flightTimes = {};
                }
            });
    }

    function removeAllCheckDay(itineraryFlightDay){
        for(var i = 0; i < 7; i++){
            if(itineraryFlightDay[i] != undefined){
                itineraryFlightDay[i] = false;
            }
        }
    }

    function formatTime(time, type){
        var newTimeSplit = time.split(":"),
            updateTime = '0:00';

        if(type == 1){
            updateTime = newTimeSplit[0] + ":" + newTimeSplit[1];
            if(newTimeSplit[0].length > 1){
                updateTime = formatTimeParse(updateTime);
            }
        }else{
            updateTime = newTimeSplit[0] + ":" + newTimeSplit[1] + ":00";
        }
        return updateTime;
    }

    function formatTimeParse(time){
        var splitTime = time.split(':'),
            splitTimeCharAt = parseInt(splitTime[0].charAt(0)),
            newTime = time;

        if(splitTimeCharAt == 0){
            newTime = time.slice(1)
        }
        return newTime;
    }

    function days(){
        return [
            {"code": 1, "name": "global.weekdays.monday.name", "initials": "global.weekdays.monday.initials"},
            {"code": 2, "name": "global.weekdays.tuesday.name", "initials": "global.weekdays.tuesday.initials"},
            {"code": 3, "name": "global.weekdays.wednesday.name", "initials": "global.weekdays.wednesday.initials"},
            {"code": 4, "name": "global.weekdays.thursday.name", "initials": "global.weekdays.thursday.initials"},
            {"code": 5, "name": "global.weekdays.friday.name", "initials": "global.weekdays.friday.initials"},
            {"code": 6, "name": "global.weekdays.saturday.name", "initials": "global.weekdays.saturday.initials"},
            {"code": 7, "name": "global.weekdays.sunday.name", "initials": "global.weekdays.sunday.initials"}
        ];
    }

    function isRequiredCheck(vm){
        for(var i=1; i<=7; i++){
            if(vm.dayCheck[i]){
                return false;
                break;
            }
        }
        return true;
    }

    function validateDepartureArrivalTime(vm, indexX, indexY, form, $timeout) {
        $timeout(function () {
            vm.stretchRoutesLength = vm.itineraryFlight.departures[indexX].stretchRoutes.length;
            angular.forEach(vm.itineraryFlight.departures[indexX].stretchRoutes, function (stretchRoute, indexStretchRoute) {
                var departureTime = stretchRoute.departureTime,
                    arrivalTime = stretchRoute.arrivalTime,
                    departureTimeSplit = departureTime.split(':'),
                    arrivalTimeSplit = arrivalTime.split(':'),
                    departureTimeTotal = departureTimeSplit[0] + departureTimeSplit[1],
                    arrivalTimeTotal = arrivalTimeSplit[0] + arrivalTimeSplit[1],
                    departureTimeKey = 'departureTime_' + indexX + '_' + indexStretchRoute,
                    arrivalTimeKey = 'arrivalTime_' + indexX + '_' + indexStretchRoute;

                if(parseInt(departureTimeTotal) === parseInt(arrivalTimeTotal)){
                    form[arrivalTimeKey].$setValidity('equalArrivalTime', false);

                } else {
                    form[arrivalTimeKey].$setValidity('equalArrivalTime', true);
                }

                if(parseInt(departureTimeTotal) > parseInt(arrivalTimeTotal)){
                    form[arrivalTimeKey].$setValidity('minorArrivalTime', false);

                } else {
                    form[arrivalTimeKey].$setValidity('minorArrivalTime', true);
                }

                if(indexStretchRoute < (vm.stretchRoutesLength-1)) {
                    var departureTimeNext = vm.itineraryFlight.departures[indexX].stretchRoutes[indexStretchRoute+1].departureTime,
                        arrivalTimeNext = vm.itineraryFlight.departures[indexX].stretchRoutes[indexStretchRoute+1].arrivalTime,
                        departureTimeNextSplit = departureTimeNext.split(':'),
                        arrivalTimeNextSplit = arrivalTimeNext.split(':'),
                        departureTimeTotalNext = departureTimeNextSplit[0] + departureTimeNextSplit[1],
                        arrivalTimeTotalNext = arrivalTimeNextSplit[0] + arrivalTimeNextSplit[1],
                        departureTimeKeyNext = 'departureTime_' + indexX + '_' + (indexStretchRoute+1),
                        arrivalTimeKeyNext = 'arrivalTime_' + indexX + '_' + (indexStretchRoute+1);

                    if(parseInt(arrivalTimeTotal) === parseInt(departureTimeTotalNext)){
                        form[departureTimeKeyNext].$setValidity('equalDepartureTime', false);
                    } else {
                        form[departureTimeKeyNext].$setValidity('equalDepartureTime', true);
                    }

                    if(parseInt(arrivalTimeTotal) > parseInt(departureTimeTotalNext)){
                        form[departureTimeKeyNext].$setValidity('minorDepartureTime', false);
                    } else {
                        form[departureTimeKeyNext].$setValidity('minorDepartureTime', true);
                    }
                }
            });
        }, 100);
    }
})();
